export function createTranscriptValidationError(confidence: number) {
    const error = new Error(`Transcript validation value should be between 0 and 1. The value is ${confidence}`);
    error.name = 'TranscriptValidationError';
    return error;
}
